import React, { useEffect, useContext } from "react";
import { motion } from "framer-motion";
import { ThemeContext } from "../context/ThemeContext";

const sectionVariant = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6 }
  }
};

const PrivacyPolicy = () => {
  const { theme } = useContext(ThemeContext);
  const isDark = theme === "dark";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className={`${isDark ? "dark" : ""} w-full mx-auto py-32 bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 mt-10`}>
      <motion.div
        initial="hidden"
        animate="visible"
        variants={sectionVariant}
        className="space-y-6 px-4 max-w-5xl mx-auto"
      >
        <h1 className="text-4xl font-bold text-center text-blue-600 dark:text-blue-400 mb-8">Privacy Policy</h1>

        <p><strong>Effective Date:</strong> 01 Apr 2025</p>
        <p>At Tripocation Holiday Pvt. Ltd., we are committed to safeguarding your privacy and ensuring the security of your personal information. This Privacy Policy outlines how we collect, use, disclose, and protect your data when you use our website and services.</p>

        <h2 className="text-2xl font-semibold text-blue-500 dark:text-blue-400">Information We Collect</h2>
        <ul className="list-disc pl-5 space-y-2">
          <li><strong>Personal Information:</strong> When you make a booking or contact us, we may collect information such as your name, email address, phone number, and travel preferences.</li>
          <li><strong>Payment Information:</strong> To process payments, we may collect payment card details or other financial information. Please note that we do not store payment card information after the transaction is complete.</li>
          <li><strong>Log Data:</strong> Our servers automatically collect log information, including your IP address, browser type, referral URL, and pages visited on our website.</li>
          <li><strong>Cookies:</strong> We use cookies and similar tracking technologies to enhance your experience on our website. You can adjust your browser settings to manage cookies or other tracking mechanisms.</li>
          <li><strong>Device Information:</strong> We may collect information about your device, including the type, operating system, and unique identifiers.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-blue-500 dark:text-blue-400">How We Use Your Information</h2>
        <ul className="list-disc pl-5 space-y-2">
          <li><strong>Process Bookings:</strong> We use the information you provide to process your bookings, manage your reservations, and communicate with you about your travel arrangements.</li>
          <li><strong>Personalize Your Experience:</strong> We may use your information to tailor our services and recommendations to your preferences and interests.</li>
          <li><strong>Improve Our Services:</strong> We analyze usage data to improve our website functionality, enhance user experience, and optimize our marketing efforts.</li>
          <li><strong>Communicate With You:</strong> We may send you promotional emails, newsletters, or other marketing communications about our products and services, but you can opt out at any time.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-blue-500 dark:text-blue-400">Information Sharing and Disclosure</h2>
        <ul className="list-disc pl-5 space-y-2">
          <li><strong>Travel Partners:</strong> We may share your information with airlines, hotels, tour operators, and other service providers to fulfil your travel bookings.</li>
          <li><strong>Service Providers:</strong> We may engage third-party service providers to assist with website maintenance, data analysis, and other support services.</li>
          <li><strong>Legal Requirements:</strong> We may disclose your information as required by law or in response to legal processes, such as court orders or government requests.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-blue-500 dark:text-blue-400">Your Rights</h2>
        <ul className="list-disc pl-5 space-y-2">
          <li>Access, correct, or delete your personal information.</li>
          <li>Object to the processing of your data.</li>
          <li>Withdraw your consent for marketing communications.</li>
          <li>Request a copy of the information we hold about you.</li>
        </ul>
        <p>To exercise your rights or request information about the data we hold, please contact us at <a href="mailto:prince@tripocationholiday.com" className="text-blue-600 dark:text-blue-300 underline">prince@tripocationholiday.com</a>.</p>

        <h2 className="text-2xl font-semibold text-blue-500 dark:text-blue-400">Data Security</h2>
        <p>We employ industry-standard security measures to protect your information from unauthorized access, disclosure, alteration, and destruction. Despite our best efforts, no data transmission over the internet or electronic storage can be guaranteed as completely secure.</p>

        <h2 className="text-2xl font-semibold text-blue-500 dark:text-blue-400">Updates In Privacy Policy</h2>
        <p>Tripocation Holiday Pvt. Ltd. reserve the right to modify this Privacy Policy at any time, so please review it frequently. Changes and clarifications will take effect immediately upon posting on the website.</p>
        <p>By using our website or booking our services, you consent to the terms of this Privacy Policy. If you have any questions or concerns about our privacy practices, please contact us.</p>

        <h2 className="text-2xl font-semibold text-blue-500 dark:text-blue-400">Contact Us</h2>
        <p>If you have questions, concerns, or require additional information about our Privacy Policy, please contact us at <a href="mailto:prince@tripocationholiday.com" className="text-blue-600 dark:text-blue-300 underline">prince@tripocationholiday.com</a>.</p>

        <p className="mt-6 font-medium">Thank you for choosing Tripocation Holiday Pvt. Ltd. for your travel needs. We are dedicated to providing you with exceptional travel experiences while respecting your privacy.</p>
      </motion.div>
    </section>
  );
};

export default PrivacyPolicy;
